import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

export default function SeoHead({ title, description, ogTitle, ogDescription, ogImage, ogUrl, twitterCard, breadcrumb }) {
  const location = useLocation();
  const canonicalUrl = ogUrl || `https://pulsecio.com${location.pathname}`;
  const fullOgImage = ogImage?.startsWith('http') ? ogImage : `https://pulsecio.com${ogImage || '/images/og/pulsecio-cover.png'}`;
  const resolvedOgTitle = ogTitle || title;
  const resolvedOgDescription = ogDescription || description;

  const breadcrumbSchema = breadcrumb ? JSON.stringify({
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Accueil", "item": "https://pulsecio.com/" },
      { "@type": "ListItem", "position": 2, "name": breadcrumb.name, "item": `https://pulsecio.com${breadcrumb.path}` }
    ]
  }) : null;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />
      <link rel="alternate" hreflang="fr" href={canonicalUrl} />
      <link rel="alternate" hreflang="x-default" href={canonicalUrl} />
      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="fr_FR" />
      <meta property="og:site_name" content="PulseCIO" />
      <meta property="og:title" content={resolvedOgTitle} />
      <meta property="og:description" content={resolvedOgDescription} />
      <meta property="og:image" content={fullOgImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={resolvedOgTitle} />
      <meta property="og:url" content={canonicalUrl} />
      {/* Twitter Card */}
      <meta name="twitter:card" content={twitterCard || "summary_large_image"} />
      <meta name="twitter:site" content="@PulseCIO" />
      <meta name="twitter:title" content={resolvedOgTitle} />
      <meta name="twitter:description" content={resolvedOgDescription} />
      <meta name="twitter:image" content={fullOgImage} />
      <meta name="twitter:image:alt" content={resolvedOgTitle} />
      {/* BreadcrumbList JSON-LD */}
      {breadcrumbSchema && (
        <script type="application/ld+json">{breadcrumbSchema}</script>
      )}
    </Helmet>
  );
}
